export default{
    outInvoice:{
        Headers:{
            title:"Orders with payment terms will be invoiced collectively upon settlement",
            title1:"Invoice Management",
            title2:"Select Merchant",
            title3:"Select Orders",
            title4:"Select Invoice Title",
        },
        form:{
            query:"Order Number",
            invoApplyStatus:"Invoice Status",
            datepicker:"Payment Date",
            defaultFlag:"Default Title",
            defaultFlag1:"Set as Default",
            price:"Invoiceable Amount",
            shopName:"Billing Merchant",
            invoTitle:"Invoice Title",
            applyRemarks:"Remarks (will appear on invoice)",
        },
        placeholder:{
            query:"Enter order number",
            invoApplyStatus:"All",
            datepicker:["Start date","End date"],
            applyRemarks:"These remarks will appear on the invoice. Enter if needed, otherwise leave blank"
        },
        steps:{
            step:"Select Merchant",
            step1:"Select Orders for Invoicing",
            step2:"Confirm Invoice Details & Address",
        },
        rules:{invoTitle:"Please select an invoice title"},
        Message:{
               warning:"Please select orders for invoicing!",
               success:"Invoice generated successfully"
        },
        Alert:{
        },
        Button:{
            btndraft:"Generate Invoice Now",
            goInvo:'Create Invoice',
            btnInvoTile:"Manage Invoice Titles",
            btnSeach:"Search",
            btnReset:"Reset",
            btnDetail:"View Details",
            btnConfirm:"Confirm",
            btnstep:"Previous",
            btnNext:"Next",
            addInvoices:"Edit Title"
        },
        Placeholder:{
        },
        Validate:{
        },
        Description:{
            noData:'No invoices available',
            emptyText:"No data",
            emptyText1:"Max 25 Chinese chars or 50 alphanumeric chars to avoid seal overlap",
        },
        Table:{
            headerName:['Merchant Name','Invoiceable Orders','Order Amount','Refund Amount','Invoiceable Amount','Action'],
            headerName1:['Order Number','Merchant Name','Order Amount','Refund Amount','Invoiceable Amount','Payment Date','Action'],
        }
    }
}